<!-- 
	This is the sign in page, it uses the dashboard layout in: 
	"./layouts/Default.vue" .
 -->

 <template>
	<div class="sign-in bg-gray-3">
		
		<a-row type="flex" :gutter="[24,24]" justify="space-around" align="middle" style="margin-top: 80px;">

			<a-col :span="24" :md="8" :lg="8" :xl="{span: 8, offset: 0}" class="col-form pt-20 mt-20">
				
				<a-card :bordered="false" class="card-info px-0 mx-0 pt-20">
					<a-row :gutter="[24,24]">
						
						<a-col :span="24" :md="24" :lg="24" class="px-25">
							<a-row class="text-center">
								<a-col :lg="24">
									<img src="../../public/images/icon.png" alt="" width="80px" height="80px" style="border-radius: 20px;"> 
								</a-col>
							</a-row>
							<h3 class="mb-0 mt-10 text-center">Verify Account!</h3>
							<p class="text-muted text-center mt-0 pt-0 mb-4">A token has been sent to your phone number or email you submitted in previous step.</p>

							<a-alert
								class="mb-20"
								v-if="error.show"
								:message="error.message"
								type="error"
								closable
								:after-close="handleClose"
								show-icon 
							/>

							<a-form
								id="components-form-demo-normal-login"
								:form="form"
								class="login-form"
								@submit="handleSubmit"
								:hideRequiredMark="true">

								<a-form-item class="mb-5" label="Token" :colon="false">
									<a-input
									v-decorator="[
									'token',
									{ rules: [{ required: true, message: 'Please input token!' }] },
									]" type="text" placeholder="Token" />
								</a-form-item>

								<a-form-item class="mt-10">
									<a-button id="signinBtn" :loading="isLoading" type="silabu" block html-type="submit" class="login-form-button mt-10 text-white" >
										VERIRY
									</a-button>
								</a-form-item>


								<a-row :gutters="24" class="pt-0">
									<a-col :span="24" class="text-center pb-5">
										Didn't receive the token?&nbsp; <a-button type="text"  class="pl-0" style="font-size: 14px; text-decoration: none !important; color: #632163; border: none;" :href="`/sign-up`">
											<strong>Resend</strong>
										</a-button>
									</a-col>
								</a-row>

								<!-- <a-row :gutters="24" class="pt-10 pb-10">
									<a-col :span="24" class="text-center pb-5">
										Already have an account? <a class="" style="text-decoration: none !important; color: #632163;" :href="`/sign-up`">
											<strong>Sign in</strong>
										</a>
									</a-col>
								</a-row> -->

							</a-form>
						</a-col>
					</a-row>
				</a-card>
			</a-col>


		</a-row>
		
	</div>
</template>

<script>
	import VueCountryCode from "vue-country-code-select";
	import { notification } from 'ant-design-vue';
	
	export default ({
		components: {
			VueCountryCode
		},

		data() {
			return {
				// Binded model property for "Sign In Form" switch button for "Remember Me" .
				error: {
					message: null,
					show: false,
				},

				countryCode: '255',

				isLoading: false,
			}
		},
		beforeCreate() {
			// Creates the form and adds to it component's "form" property.
			this.form = this.$form.createForm(this, { name: 'normal_login' });
		},
		created() {
		},
		methods: {

			onSelectCountry({name, iso2, dialCode}) {
				this.countryCode = dialCode;
			},

			handleClose() {
				this.error.show = false;
			},

			// Handles input validation after submission.
			handleSubmit(e) {
				e.preventDefault();
				this.form.validateFields((err, values) => {
					if ( !err ) {
						this.error.show = false;
						this.error.message = null;
						this.isLoading = true;

						const token = values.token;

						let url = `${this.$BACKEND_URL}/auth/verify`;
						
						this.$AXIOS.post(url, { token }).then(async(response) => {
							if (response.status >= 200 && response.status < 210) {

								this.notify("success", "Account verification was successfully")
								
								this.isLoading = false;
								

								this.$router.push(`/sign-in`);
							}

							this.isLoading = false
						}).catch((error) => {
							console.log(error)
							this.isLoading = false;
							
							this.error.message = error.response != null  && error.response.data != null ? error.response.data.message : "Connection error";
							this.error.show = true
						});
					}
				});
			},

			notify(type, message) {
				this.$notification.open({
					class: 'ant-notification-' + type,
					message: message,
					duration: 3.0,
					style: {fontSize: "10px !important"}
				});
			},
		},
		
	})

</script>

<style lang="scss" scoped>
	body {
		background-color: #ffffff;
	}
	#signinBtn, #signinBtn:hover {
		background-color: #632163 !important;
		color: white !important;
	}
</style>
<!-- 
	This is the sign in page, it uses the dashboard layout in: 
	"./layouts/Default.vue" .
 -->
